import { useQuery } from "@tanstack/react-query";
import { moduleTaskApi } from "./axios";
import {
  // DataI,
  // MigrationsI,
  // PropsI,
  ServiceResponseI,
  TaskI,
} from "../../interfaces";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { AxiosError } from "axios";

export const getAllTaskbyModule = async (
  id: number,
): Promise<ServiceResponseI<TaskI[]>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const { data } = await moduleTaskApi.get<ServiceResponseI<TaskI[]>>(
      `/all-task-by-module-id/${id}`,
      { headers: { Authorization: validateToken } },
    );
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};
